import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RiskProfileRoutingModule } from './risk-profile-routing.module';
import { RiskProfileComponent } from './components/risk-profile.component';
import { RiskProfileService } from './components/risk-profile.service';
import { CanActivateViaAuthGuard } from '../../shared/services/auth.service';

@NgModule({
  imports: [
    CommonModule,
    RiskProfileRoutingModule,
    TranslateModule.forChild()
  ],
  declarations: [RiskProfileComponent],
  providers: [
    CanActivateViaAuthGuard, RiskProfileService
  ]
})
export class RiskProfileModule { }
